export { validatorPositive as validatorPositive };
export { validatorPassword as validatorPassword };
export { validatorCreditCard as validatorCreditCard };
export { validatorUrlValidator as validatorUrlValidator };
export { validatorTxHash as validatorTxHash };
export { validatorIPV4_6 as validatorIPV4_6 };
export { validatorMinAmount as validatorMinAmount };
export { validatorMaxAmount as validatorMaxAmount };
export { validatorMinAmountQuantity as validatorMinAmountQuantity };
export { validatorMaxAmountQuantity as validatorMaxAmountQuantity };
export { validatorMinQuantity as validatorMinQuantity };
export { validatorMaxQuantity as validatorMaxQuantity };
export { validatorMinOrderLimit as validatorMinOrderLimit };
export { validatorMaxOrderLimit as validatorMaxOrderLimit };
export { validatorMaxSelectionRule as validatorMaxSelectionRule };
export { validateAddress as validateAddress };
const validatorPositive = value => {
  if (value >= 0) {
    return true;
  }
  return false;
};
const validatorPassword = password => {
  /* eslint-disable no-useless-escape */
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/;
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password);
  return validPassword;
};
const validatorCreditCard = creditnum => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/;
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum);
  return validCreditCard;
};
const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true;
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
  /* eslint-enable no-useless-escape */
  return re.test(val);
};
const validatorTxHash = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true;
  }
  return val.length >= 64 && val.length <= 100;
};
const validatorIPV4_6 = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true;
  }
  const re = /(?:^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$)|(?:^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?$)/;
  /* eslint-enable no-useless-escape */
  return re.test(val);
};
const getLimit = arg => {
  if (arg === undefined || arg === null) return NaN;
  if (typeof arg === 'number') return arg;
  if (Array.isArray(arg)) return Number(arg[0]);
  if (typeof arg === 'object') {
    const keys = Object.keys(arg);
    return keys.length > 0 ? Number(arg[keys[0]]) : NaN;
  }
  return Number(arg);
};

const validatorMinAmount = (val, min) => {
  if (val === undefined || val === null || val === '') return true;
  const limit = getLimit(min);
  if (isNaN(limit)) return true;
  return Number(val) >= limit || `A minimum price of ${limit} is required.`;
};
const validatorMaxAmount = (val, max) => {
  if (val === undefined || val === null || val === '') return true;
  const limit = getLimit(max);
  if (isNaN(limit)) return true;
  return Number(val) <= limit || `A maximum price of ${limit} is required.`;
};
const validatorMinAmountQuantity = (val, min) => {
  if (val === undefined || val === null || val === '') return true;
  const limit = getLimit(min);
  if (isNaN(limit)) return true;
  return Number(val) >= limit || `A minimum amount is ${limit}.`;
};
const validatorMaxAmountQuantity = (val, max) => {
  if (val === undefined || val === null || val === '') return true;
  const limit = getLimit(max);
  if (isNaN(limit)) return true;
  return Number(val) <= limit || `A maximum amount is ${limit}.`;
};
const validatorMinQuantity = (val, min) => {
  if (val === undefined || val === null || val === '') return true;
  const limit = getLimit(min);
  if (isNaN(limit)) return true;
  return Number(val) >= limit || `A minimum quantity is ${limit}`;
};
const validatorMaxQuantity = (val, max) => {
  if (val === undefined || val === null || val === '') return true;
  const limit = getLimit(max);
  if (isNaN(limit)) return true;
  return Number(val) <= limit || `A maximum quantity is ${limit}`;
};
const validatorMinOrderLimit = (val, min) => {
  if (val === undefined || val === null || val === '') return true;
  const limit = getLimit(min);
  if (isNaN(limit)) return true;
  return Number(val) >= limit || `A minimum order limit of ${limit} is required.`;
};
const validatorMaxOrderLimit = (val, max) => {
  if (val === undefined || val === null || val === '') return true;
  const limit = getLimit(max);
  if (isNaN(limit)) return true;
  return Number(val) <= limit || `A maximum order limit of ${limit} is required.`;
};
const validatorMaxSelectionRule = (val, max) => {
  if (val === undefined || val === null || val.length === 0) return true;
  const limit = getLimit(max);
  if (isNaN(limit)) return true;
  return (Array.isArray(val) ? val.length : 1) <= limit || `The field may not have more than ${limit} items.`;
};
const validateAddress = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true;
  }
  const btcPattern = /^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$/;
  const ethPattern = /^(0x)?[0-9a-fA-F]{40}$/;
  const tronPattern = /^T[a-zA-Z0-9]{33}$/;
  const isValidAddress = btcPattern.test(val) || ethPattern.test(val) || tronPattern.test(val);
  return isValidAddress;
};

export default { validatorPositive, validatorPassword, validatorCreditCard, validatorUrlValidator, validatorTxHash, validatorIPV4_6, validatorMinAmount, validatorMaxAmount, validatorMinAmountQuantity, validatorMaxAmountQuantity, validatorMinQuantity, validatorMaxQuantity, validatorMinOrderLimit, validatorMaxOrderLimit, validatorMaxSelectionRule, validateAddress };
